import { Component, OnInit } from '@angular/core';
import { RoutingService } from '../../services';
import { AuthLegacyService } from '../auth-legacy.service';
import { SharedModule } from '@Shared/shared.module';

@Component({
    selector: 'auth0-login',
    templateUrl: './auth0-login.component.html',
    styleUrls: ['./auth0-login.component.scss'],
    imports: [SharedModule]
})
export class Auth0LoginComponent implements OnInit {

    showContent = false;

    constructor(
        public authService: AuthLegacyService,
        private readonly routingService: RoutingService) { }

    ngOnInit() {
        if (this.authService.isAuthenticated()) {
            this.routingService.navigateToIntendedOrDefault();
        } else {
            this.showContent = true;
        }
    }

    signIn() {
        localStorage.setItem('legacy', 'true');
        if (this.authService.isAuthenticated()) {
            this.routingService.navigateToIntendedOrDefault();
        } else {
            this.authService.login();
        }
    }

}
